<!-- Divider -->
<div
  class="fuse-horizontal-navigation-item-wrapper divider"
  [ngClass]="$safeNavigationMigration(item.classes?.wrapper)"
></div>
